import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sharedActions from '../../Actions/sharedActions';
import SnackBar from '../../components/SnackBar/SnackBar';
import $ from 'jquery';
import isEmpty from 'lodash/isEmpty';
import Header from '../../Assets/images/3 headers-03.png';
import moment from 'moment'

import ThemeContext from "../../context/themeContext/ThemeContext";


class PrintDailyClassAttendanceReport extends Component {
    constructor(props){
        super(props);
        this.state = {
            payrollData: [],
            search: '',
            isLoading: false,
            modalEdit: false,
            editToggle: false,
            generateToggle: false,
            generateIndex: '',
            msg: '',

			accountId: this.props.userData.unique_name,
			accountType: this.props.userData.role

        }

        


    }
	static contextType = ThemeContext

    componentDidMount(){

    }

    
    PrintContent = el => {
        var restorepage = document.body.innerHTML;
        var Printcontent = document.getElementById(el).innerHTML;
        document.body.innerHTML = Printcontent;
        
        setTimeout(() => {
            window.print();
            window.location.reload();
        }, 700)
        document.body.innerHTML = restorepage;
    };


    myFunction = () => {
		// Get the snackbar DIV
		var x = document.getElementById('snackbar');

		// StepperGeneralButtons the "show" class to DIV
		x.className = 'show';

		// After 3 seconds, remove the show class from DIV
		setTimeout(function() {
		}, 3000);
	};



    render(){
        const { isLoading, accountId, accountType } = this.state;
        const { classAttendance, date } = this.props.location.state

        const Loader = (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="spinner-border" style={{ color: this.context.themeColors.primaryColor }}></div>
            </div>
        );

        const renderClassAttendanceData = classAttendance && classAttendance.Student.map((item, index) => {
            return (

            <tr key={index} >
                <th scope="row" style={{ padding: 1 }} >
                    {index + 1}
                </th>
                <td className="borderSpace" style={{ padding: 1 }}>
                    {item.StudentName}
                </td>
                {item.attendance.map((data, index2) => {
                    return <td className="borderSpace" style={{ padding: 1 } && data.attendanceStatus == 'Present' ? data.attendanceStatus == 'Present' && data.lateTime == 'yes' ? { color: 'orange'} :  { color: 'green'} : { color: 'red'}}  >
                    {data.attendanceStatus.substring(0,1) == 'A' && 
                    `${data.attendanceStatus.substring(0,1)} - ${data.leaveType.substring(0,1) == 'E' ? 'E' : 'NE'}`}
                    {data.attendanceStatus.substring(0,1) == 'P' && 
                    `${data.attendanceStatus.substring(0,1)} ${data.lateTime == 'yes' ? ' - Late' : ''}`}
                </td>
                    
                })}
            </tr>
            
            );
        }) 

        const renderSubjectList = classAttendance && classAttendance.subjectInfo.map((data, index) => {
            return <th scope="col" style={{ padding: 1 }} key={data.subjectId} >
                {data.subjectName}
            </th>
        })


        return (
            <div className="page-header"> 
                <div id="printPage" style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <div class="row" >
								<div
									style={{
                                        flex: 1,
                                        width: '100%',
                                        height: '100%'
									}}
								>
									<img src={Header} width={'100%'} height={'100%'} />
								</div>
						</div>

                    <div class="row my-2 mx-2 colCheckb justify-content-between" style={{marginTop: '2%', paddingLeft: '20px'}} >
							<div class="text-center col-xs-12 col-sm-12 col-md-12">
								<h3>Daily Class Attendance</h3>
								
							</div>
						</div>
                        

                    <div class="row my-2 mx-2 colCheckb justify-content-between " style={{paddingLeft: '20px'}} >
                            <div class="col-md-6" >
                                    <span>Class: <strong style={{color: this.context.themeColors.primaryColor}} >{classAttendance && classAttendance.info.className}</strong></span>     
                            </div>
                            <div class="col-md-6 text-right"  >
                                    <span>Section: <strong style={{color: this.context.themeColors.primaryColor}} >{classAttendance && classAttendance.info.section}</strong></span>     
                            </div>
                            <div class="col-md-6" >
                                    <span>Date: <strong style={{color: this.context.themeColors.primaryColor}} >{classAttendance && classAttendance.info.date}</strong></span>     
                            </div>
                            <div class="col-md-6 text-right" >
                                    <span>Session: <strong style={{color: this.context.themeColors.primaryColor}} >{classAttendance && classAttendance.info.sessionName}</strong></span>     
                            </div>
                        </div>
                    
                    
                    
                    <div className="table-responsive">
					<table className="table table-hover table-bordered text-center">
						<thead style={{ background: this.context.themeColors.primaryColor, color: 'white' }}>
							<tr>
								<th scope="col" style={{ padding: 1 }}>
									#
								</th>
								<th scope="col" style={{ padding: 1 }}>
									Student Name
								</th>
                                {renderSubjectList}
							</tr>
						</thead>
						<tbody>{isLoading ? Loader : renderClassAttendanceData}</tbody>
					</table>
				</div>
                </div>
                <div class="row" style={{marginBottom: '2%', marginRight: '1%'}} >
                    <div class="col-md-4">
                            <span>Printed By: <strong style={{color: this.context.themeColors.primaryColor}} >{this.props.userData.unique_name}</strong></span>     
                    </div>
                    <div class="col-md-4 text-center">
                             
                            <span>Role: <strong style={{color: this.context.themeColors.primaryColor}} >{this.props.userData.role}</strong></span>     

                    </div>
                    <div class="col-md-4 text-right">
                             
                            <span>Time: <strong style={{color: this.context.themeColors.primaryColor}} >{moment().format('HH:mm - MM/DD/YYYY')}</strong></span>     

                    </div>
                </div>
                <div class="row" style={{marginBottom: '2%', marginRight: '1%'}} >
                    <div class="col-md-12 text-right">
                    <button class="btn btn-primary buttonAppear no-print" onClick={() => this.PrintContent('printPage')}>
                            <i class="fas fa-print"></i> Print
                        </button>
                    </div>
                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
	return {
		sharedActions: bindActionCreators(sharedActions, dispatch),
	};
}
function mapStateToProps(state) {
	return {
		userData: state.setUserReducer.users,
	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PrintDailyClassAttendanceReport);
